module.exports = __webpack_public_path__ + "img/2400.166da92e.jpg";